import React from 'react';

import { Link as RouterLink, useLocation } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

import GHAParticipationReportContainer from '~/components/GHAParticipationReport/GHAParticipationReportContainer';

import CompetitorOffersContainer from './CompetitorOffersContainer';
import { COMPETITOR_OFFERS_PATH, CUSTOMER_DEMAND_PATH } from './constants';

export default function CompetitorOffersPage() {
  const { pathname } = useLocation();
  const view = pathname.startsWith(CUSTOMER_DEMAND_PATH) ? CUSTOMER_DEMAND_PATH : COMPETITOR_OFFERS_PATH;

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={view}>
          <Tab
            component={RouterLink}
            to={COMPETITOR_OFFERS_PATH}
            value={COMPETITOR_OFFERS_PATH}
            label="Competitor offers"
          />
          <Tab component={RouterLink} to={CUSTOMER_DEMAND_PATH} value={CUSTOMER_DEMAND_PATH} label="Customer demand" />
        </Tabs>
      </Box>

      {view === COMPETITOR_OFFERS_PATH && <CompetitorOffersContainer />}
      {view === CUSTOMER_DEMAND_PATH && <GHAParticipationReportContainer />}
    </Box>
  );
}
